<template>
    <div class="bannerContainer">
        <div id="bannerBg">
            <div>
                <p id="bannerTitle">典型客户分布</p>
                <div id="bannerText">
                    主要客户分布在天津、河北、山东、辽宁、黑龙江等等，其中还有国家专项“十一·五”专项，“十二·五”课题的参与。
                </div>
                <button id="bannerBtn" @click="returnTop('#caseList')">查看详情</button>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: 'Screen1',
    methods:{
        returnTop:function(dis){
            document.querySelector(dis).scrollIntoView({behavior:'smooth',block:'center'});
        }
    }
}
</script>

<style scoped>
    .bannerContainer{
        padding-top: 50px;
        background: #171b26;
    }
    #bannerBg{
        margin: 0 auto;
        width: 885px;
        height: 335px;
        background: url(../../assets/imgs/case/bbg.jpg);
        color: #fff
    }
    #bannerBg>div{
        padding: 110px 0 75px 85px; 
    }
    #bannerTitle{
        font-size: 24px;
        margin-bottom: 25px;
    }
    #bannerText{
        font-size: 14px;
        width: 410px;
        line-height: 20px;
    }
    #bannerBtn{
        font-size: 12px;
        color: #000;
        margin-top: 30px;
        cursor: pointer;
        padding: 5px 10px;
        border-radius: 5px;
        border: 0;
        background: -webkit-linear-gradient(#4db9f1, #307d74); /* Safari 5.1 - 6.0 */
        background: -o-linear-gradient(#4db9f1, #307d74); /* Opera 11.1 - 12.0 */
        background: -moz-linear-gradient(#4db9f1, #307d74); /* Firefox 3.6 - 15 */
        background: linear-gradient(#4db9f1, #307d74); /* 标准的语法 */
    }
</style>
